import React, { useEffect, useState } from 'react';
import './businessTreatmentcategories.scss';
import NavHeader from '../../../common/NavHeader/NavHeader';
import { ReactComponent as CategoriesIcon } from '../../../../images/business-setting-icon/CategoriesIcon.svg';
import { ReactComponent as BulbIcon } from '../../../../images/business-setting-icon/Bulb.svg';
import rightArrow from '../../../../images/icons/chevron-left.svg';
import { useNavigate } from 'react-router';
import { getBusinessSettingPage } from '../../../../Routes';
import { useDispatch, useSelector } from 'react-redux';
import { CLEAR_CATEGORIES_LIST, RES_PER_PAGE, SAVE_CATEGORIES_LIST, } from '../../../redux/constants/treatment-list-const/TreatmentListConst';
import InfiniteScroll from 'react-infinite-scroll-component';
import SkeletonLoader from '../../../common/Skeleton/SkeletonLoader';
import CustomeHeading from '../../../customeHeading/customeHeading';
import useWindowDimension from '../../../../utils/useWindowDimensions';
import CustomeDeleteModel from '../../../CustomeDeleteModel/CustomeDeleteModel';
import { CreateOrUpdateCategoryAction, DeleteTreatmentCategoryAction, GetCategoryListAction } from '../../../redux/actions/treatmentList/getTreatmentsDetails';
import showToast from '../../../common/CustomToast/CustomToast';
import CustomModal from '../../../modal/CustomModal';
import { ReactComponent as RightArrow } from "../../../../images/new-appointment/right_arrow.svg";
import { ReactComponent as EditIcon } from "../../../../images/icons/appointment-list/EditAppointmentIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../images/icons/appointment-list/delete.svg";
import TextInput from '../../../common/TextInput';
import StepButton from '../../../common/StepButton';
import Skeleton from "react-loading-skeleton";


function getUniqueCategories(arr) {
	const uniqueCategories = [];
	const categoryIds = new Set();

	arr.forEach(item => {
		if (!categoryIds.has(item.categoryId)) {
			uniqueCategories.push(item);
			categoryIds.add(item.categoryId);
		}
	});

	return uniqueCategories;
}

function BusinessTreatmentcategories() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const dimensions = useWindowDimension();
	const [newCategoryModalOpen, setNewCategoryModalOpen] = useState(false);
	const [updateCategoryModalOpen, setUpdateCategoryModalOpen] = useState(false);
	const [isDeleteConfPopupOpen, setIsDeleteConfPopupOpen] = useState(false);
	const [SelectedCategories, setSelectedCategories] = useState({});

	const [isChooseActionOpen, setIsChooseActionOpen] = useState(false);
	const [newCategoryName, setNewCategoryName] = useState('');
	const [addedCategoriesList, setAddedCategoriesList] = useState([]);
	const { initGetCategoryList, getCategoryListStatus } = GetCategoryListAction();
	const { initCreateOrUpdateCategory, createOrUpdateCategoryStatus } = CreateOrUpdateCategoryAction();
	const { categoriesList, hasMore, curPage } = useSelector((state) => state.TreatmentCategoriesReducer);
	const { deleteTreatmentCategoryStatus, initDeleteTreatmentCategory } = DeleteTreatmentCategoryAction();

	const mergedCategoriesList = getUniqueCategories(addedCategoriesList.concat(categoriesList));
	
	const getCategoryListHelper = (shallRefresh) => {

		let newPage = curPage + 1 ;
		if (shallRefresh) {
			dispatch({
				type: CLEAR_CATEGORIES_LIST,
			});
			newPage = 1;
		}
		const payload = {
			page: newPage,
			limit: RES_PER_PAGE,
		};
		const onSuccess = (data) => {
			dispatch({
				type: SAVE_CATEGORIES_LIST,
				payload: data,
			});
		};
		initGetCategoryList(payload, onSuccess);
	};


	const createCategoryHelper = () => {
		const payload = {
			
			categoryName: newCategoryName,
		};
		const onSuccess = (data) => {
			const catId = data?.data?.categoryId;
            setAddedCategoriesList((prev) => {
                return [{ categoryId: catId, categoryName: newCategoryName }, ...prev];
            });
			setNewCategoryModalOpen(false);
			setNewCategoryName('');
			showToast('success', data.message);
		};
		const onError = (res) => {
			showToast('error', res.message);
		};
		initCreateOrUpdateCategory(payload, onSuccess, onError);
	};

	const updateCategoryHelper = () => {
		const payload = {
			categoryId: SelectedCategories?.categoryId,
			categoryName: newCategoryName,
		};

		const onSuccess = (data) => {
			const updatedData = mergedCategoriesList?.map((item) => {
				console.log("testdata",item.categoryId,SelectedCategories?.categoryId,newCategoryName)
				if (item.categoryId == SelectedCategories?.categoryId) {
					return { ...item, categoryName: newCategoryName }
				}
				else {
					return { ...item }
				}
			})
			setAddedCategoriesList(updatedData);
			setUpdateCategoryModalOpen(false)
			showToast('success', data.message);
		};
		const onError = (res) => {
			showToast('error', res.message);
		};
		initCreateOrUpdateCategory(payload, onSuccess, onError);
	};

	const handleDeleteTreatment = () => {
		initDeleteTreatmentCategory(
			{
				deleteTreatmentCategoryId: SelectedCategories?.categoryId,
			},
			(res) => {
				console.log("Delete Success:", res);
				showToast('success', res.message);
				const updatedData = mergedCategoriesList?.filter(
					(item) => item.categoryId !== SelectedCategories?.categoryId // Only keep items that don't match the deleted one
				);
				setAddedCategoriesList(updatedData);
				getCategoryListHelper(true)
				setIsDeleteConfPopupOpen(false);
				setIsChooseActionOpen(false);
			},
			(err) => {
				console.error("Delete Error:", err);
				showToast('error', err.message);
			}
		);
	};

	useEffect(() => {
		getCategoryListHelper(true);
	}, []);

	const [headerHeight, setHeaderHeight] = useState(0);
	const [firstTreatmentSecHeight, setFirstTreatmentSecHeight] = useState(0);
	const [taglineHeight, setTaglineHeight] = useState(0);


	useEffect(() => {

		setHeaderHeight(
			document.getElementsByClassName("nav-header-without-padding-container")[0]?.offsetHeight
		);

		setFirstTreatmentSecHeight(
			document.getElementsByClassName("firstTreatmentSec")[0]?.offsetHeight
		);

		setTaglineHeight(
			document.getElementsByClassName("tagline")[0]?.offsetHeight
		);


		window.addEventListener("resize", handleResize);
	}, [headerHeight, firstTreatmentSecHeight]);

	const handleResize = () => {

		setHeaderHeight(
			document.getElementsByClassName("nav-header-without-padding-container")[0]?.offsetHeight
		);

		setFirstTreatmentSecHeight(
			document.getElementsByClassName("firstTreatmentSec")[0]?.offsetHeight
		);

		setTaglineHeight(
			document.getElementsByClassName("tagline")[0]?.offsetHeight
		);

	};



	return (
		<div className="Main-BusinessTreatmentcategories-page" id="Main-BusinessTreatmentcategories-page">
			<NavHeader
				handleOnBack={() => navigate(getBusinessSettingPage())}
				isBackOnly={true}
				applyPadding={false}
			/>
			<div className='maxWidth684 paddintTop80'>
				<div className='firstTreatmentSec'>
					<CustomeHeading
						Title='Category list'
						Desc='Use the categories to manage and organise your treatments. '
						isSearch={false}
					/>

					<div className='CustomToolTip'>
						<div className='CustomToolTipContent'>
							<h5>Faces top tip  </h5>
							<p>Regularly update your category list to showcase new treatments. A well-organised list boosts navigation and <b>improves bookings by 17%.</b></p>
						</div>
						<BulbIcon />
					</div>
					<div onClick={() => { setNewCategoryModalOpen(true); setNewCategoryName('') }} className="addClinicWrapper clinicItem">
						<div className="clinicContentWrapper">
							<div className='IconWrapper'>
								<CategoriesIcon />
							</div>
							<div className="clinicContent">
								<h5 className="clinic-title">Add new category</h5>
							</div>
						</div>
						<div className="rightIcon">
							<img className="my-auto" src={rightArrow} alt="right arrow" />
						</div>
					</div>
				</div>

				<div className="ClinicWrapper">
					<p className='tagline'>My categories</p>
					<div className="clinicGrid" id="treatment-list-wrapper-grid" style={{ height: dimensions?.height - headerHeight - firstTreatmentSecHeight - taglineHeight - 25 + 'px', overflowY: 'auto' }}>
						<InfiniteScroll
							dataLength={mergedCategoriesList.length}
							hasMore={hasMore}
							next={() => {
								getCategoryListHelper();
							}}
							scrollableTarget="treatment-list-wrapper-grid"
						>
							{mergedCategoriesList?.length > 0 &&
								mergedCategoriesList?.map((value, index) => {
									return (
										<div className='clinicItem' key={index} onClick={() => {
											setSelectedCategories(value)
											setIsChooseActionOpen(true)
											setNewCategoryName(value?.categoryName)
										}
										}>
											<div className='clinicContentWrapper'>
												<div className='IconWrapper'>
													<CategoriesIcon />
												</div>
												<div className="clinicContent">
													<h5 className="clinic-title">{value?.categoryName}</h5>
												</div>
											</div>
											<div className="RightIcon">
												<img className="my-auto" src={rightArrow} alt="right arrow" />
											</div>
										</div>
									)
								})}

								{/* {
									getCategoryListStatus?.loading && (curPage > 0 ) && 
									<SkeletonLoader type="TreatmentCategoriesList" />
								}
								 {getCategoryListStatus?.loading && (curPage === 0) &&
                       				<SkeletonLoader type="TreatmentCategoriesList" />
								} */}
								   {getCategoryListStatus.loading && (
									<SkeletonLoader type="TreatmentCategoriesList" />
                                )}
							
							{!getCategoryListStatus.loading &&
								mergedCategoriesList?.length === 0 && (
									<div className='noDataFound'>
										<p> No categories found	</p>
									</div>
								)}

						</InfiniteScroll>
					</div>
				</div>
			</div>
			<CustomModal
				modaltitle={'Create a category'}
				modalOpen={newCategoryModalOpen}
				className={'ModelMaxWidth540 CustomeCreateCategoryModel'}
				setModalOpen={() => {
					setNewCategoryModalOpen(false)
				}
				}
				modalBody={
					<div className="createCategoryModal">
						<p className="createCategoryModal__desc">
						Categories help customers browse your treatments in a tidy fashion.
						</p>
						<TextInput
							label="Category name"
							placeholder="Category name"
							value={newCategoryName}
							onChange={(e) => setNewCategoryName(e.target.value)}
						/>
						<div className='FooterbtnModel'>
							<StepButton
								isLoading={createOrUpdateCategoryStatus.loading}
								onClick={() => createCategoryHelper()}
								blue
								label="Save"
								disabled={
									newCategoryName.length === 0 ||
									createOrUpdateCategoryStatus.loading
								}
							/>
						</div>

					</div>
				}
			/>

			{/* Edit Categories */}
			<CustomModal
				modaltitle={'Rename category'}
				modalOpen={updateCategoryModalOpen}
				className={'ModelMaxWidth540 CustomeCreateCategoryModel'}
				setModalOpen={() => {
					setUpdateCategoryModalOpen(false)
				}
				}
				modalBody={
					<div className="createCategoryModal">
						<p className="createCategoryModal__desc">
						Editing the category name will update across your Faces software.
						</p>
						<TextInput
							label="Category name"
							placeholder="Category name"
							value={newCategoryName}
							onChange={(e) => setNewCategoryName(e.target.value)}
						/>
						<div className='FooterbtnModel'>
							<StepButton
								isLoading={createOrUpdateCategoryStatus.loading}
								onClick={() => updateCategoryHelper()}
								blue
								label="Save"
								// disabled={
								// 	newCategoryName.length === 0 || 
								// 	(SelectedCategories?.categoryName && SelectedCategories?.categoryName === newCategoryName) ||
								// 	createOrUpdateCategoryStatus.loading
								// }
								
							/>
						</div>

					</div>
				}
			/>

			<CustomModal
				modalOpen={isChooseActionOpen}
				setIsOpenMobileCalendar={() => setIsChooseActionOpen(false)}
				setModalOpen={() => setIsChooseActionOpen(false)}
				modaltitle={'Action'}
				modaltitleCSS={'discount-title'}
				className={'CustomeActionsform ModelMaxWidth540'}
				modalBody={
					<div className="discount-price-container">
						<div
							className="d-flex justify-content-between align-items-center cursor-pointer"
							onClick={() => {
								setIsChooseActionOpen(false);
								setUpdateCategoryModalOpen(true);
								// navigate(businessTreatmentDetailsRoute(selectedTreatmentId))
							}}
						>
							<div className="d-flex align-items-center left-content gap-3 mt-3">
								<EditIcon />
								<h1>Rename category</h1>
							</div>
							<RightArrow />
						</div>
						<div
							className="d-flex justify-content-between align-items-center cursor-pointer"
							onClick={() => {
								setIsDeleteConfPopupOpen(true);
								setIsChooseActionOpen(false);
							}}
						>
							<div className="d-flex align-items-center left-content gap-3 mt-3">
								<DeleteIcon />
								<h1>Delete category </h1>
							</div>
							<RightArrow />
						</div>
					</div>
				}
			/>

			<CustomeDeleteModel
				modalOpen={isDeleteConfPopupOpen}
				setModalOpen={setIsDeleteConfPopupOpen}
				DeleteModelTitle={'Confirm'}
				isDeleteLoading={deleteTreatmentCategoryStatus.loading}
				isDeleteDisabled={deleteTreatmentCategoryStatus.loading}
				DeleteModelDesc={`Are you sure you want to delete this category?`}
				onDeleteClick={() => {
					handleDeleteTreatment();
				}}
				onCancleClick={() => {
					setIsDeleteConfPopupOpen(false);
				}}
			/>
		</div>


	);
}

export default BusinessTreatmentcategories;
